// extracted by mini-css-extract-plugin
export default {"inputSpanBoxWrapp":"RadioInput_inputSpanBoxWrapp__OK896","bankName":"RadioInput_bankName__Acr6u","bankNumber":"RadioInput_bankNumber__8n0+Z"};